import { tradeRegions } from '@/lib/constants/regions';

export const getTradeRegionForCountry = (countryCode: string) => {
  const foundRegion = tradeRegions.find((region) => region.countries.includes(countryCode));
  return foundRegion?.name || undefined;
};
